import React, { Component, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import queryString from 'query-string';
import Link from '@material-ui/core/Link';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { useSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import CurrentUserContext from '../../contexts/CurrentUserContext';
import CardForm from '../../components/CardForm';
import * as api from '../../services/api/auth';

function Snackbar(props) {
  const { location } = props;

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.timedout) {
      enqueueSnackbar('Your session expired please login again');
    }
  }, [location]);

  return <div />;
}

class Login extends Component {
  state = {
    email: '',
    password: '',
    errorMessage: '',
    setStorageValue: null,
    setStorageSpeciality: null,
    showPassword: false,
  };

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    if (parsed && parsed.redirect1) {
      sessionStorage.setItem('redirect1', parsed && parsed.redirect1);
      this.setState({
        setStorageValue: parsed.redirect1,
        setStorageSpeciality: null,
      });
    }
    if (parsed && parsed.redirect2) {
      sessionStorage.setItem('redirect2', parsed && parsed.redirect2);
      this.setState({
        setStorageSpeciality: parsed.redirect2,
        setStorageValue: null,
      });
    }
  }

  handleClickShowPassword = () => {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  };
  
  handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  handleSubmit = async () => {
    const { setCurrentUser } = this.context;
    const { email, password } = this.state;

    try {
      const { passwordResetLink } = await api.loginUser({ email, password });
      if (passwordResetLink) {
        window.location.assign(passwordResetLink);
      } else {
        const currentUser = await api.fetchCurrentUser();
        setCurrentUser(currentUser);
        this.redirect(currentUser);
      }
    } catch (err) {
      if (err.response) {
        this.setState({ errorMessage: err.response.data.message });
        throw err.response;
      }
    }
  };

  redirect = currentUser => {
    const { history } = this.props;
    const { setStorageValue, setStorageSpeciality } = this.state;
    const origin = this.origin();
    if (currentUser.isProvider || currentUser.isAdministrator) {
      // if (setStorageValue !== '') {
      //   sessionStorage.removeItem('redirect1');
      //   window.location.assign(process.env.REACT_APP_CLIENT_URL + '/concierge-pricing')
      // } else if (setStorageSpeciality !== '') {
      //   sessionStorage.removeItem('redirect2');
      //   window.location.assign(process.env.REACT_APP_CLIENT_URL + '/specialties/search');
      // }
      if (setStorageValue !== null) {
        sessionStorage.removeItem('redirect1');
        sessionStorage.removeItem('redirect2');
        this.setState({
          setStorageValue: null,
        });
        // window.location.assign(process.env.REACT_APP_CLIENT_URL + '/concierge-pricing');
        window.location.assign('https://qwell.com/concierge-pricing');
      } else if (setStorageSpeciality !== null) {
        this.setState({
          setStorageSpeciality: null,
        });
        sessionStorage.removeItem('redirect1');
        if (
          process.env.CLIENT_URL == 'undefined' ||
          process.env.CLIENT_URL == undefined
        ) {
          sessionStorage.removeItem('redirect2');
          // window.location.assign(process.env.CLIENT_URL + '/specialties/search');
          window.location.assign('https://qwell.com/specialties/search');
        } else {
          sessionStorage.removeItem('redirect2');
          // window.location.assign('https://qwell.com/specialties/search');
          window.location.assign(
            process.env.REACT_APP_CLIENT_URL + '/specialties/search'
          );
        }
      } else {
        // history.push('/admin/notifications');
        history.push('/admin/schedule/weekview'); // To avoid inital load after login
      }
    } else if (origin) {
      if (origin === 'back') {
        if (localStorage.getItem('info')) {
          const urlCode = JSON.parse(localStorage.getItem('info'));
          const searchKey = urlCode.search.replace('undefined', '');
          localStorage.removeItem('info');
          history.push(urlCode.pathname + searchKey + currentUser.patient.id);
        } else {
          history.goBack();
        }
      } else if (origin === 'pathUrl') {
        if (localStorage.getItem('pathUrl')) {
          const urlCode = JSON.parse(localStorage.getItem('pathUrl'));
          const searchKey = urlCode.search.replace('undefined', '');
          localStorage.removeItem('pathUrl');
          history.push(urlCode.pathname + searchKey + currentUser.patient.id);
        } else {
          history.goBack();
        }
      } else if (origin === 'pathRedirect') {
        if (localStorage.getItem('pathRedirect')) {
          const urlCode = JSON.parse(localStorage.getItem('pathRedirect'));
          const searchKey = urlCode.search.replace('undefined', '');
          localStorage.removeItem('pathRedirect');
          history.push(urlCode.pathname + searchKey + currentUser.patient.id);
        } else {
          history.goBack();
        }
      } else {
        history.push(origin);
      }
    } else {
      if (setStorageValue !== null) {
        this.setState({
          setStorageValue: null,
        });
        sessionStorage.removeItem('redirect1');
        sessionStorage.removeItem('redirect2');
        // REACT_APP_HOMEPAGE_URL
        // window.location.assign(process.env.REACT_APP_CLIENT_URL + '/concierge-pricing');
        window.location.assign('https://qwell.com/concierge-pricing');
      } else if (setStorageSpeciality !== null) {
        this.setState({
          setStorageSpeciality: null,
        });
        sessionStorage.removeItem('redirect1');
        if (
          process.env.CLIENT_URL == 'undefined' ||
          process.env.CLIENT_URL == undefined
        ) {
          sessionStorage.removeItem('redirect2');
          // window.location.assign(process.env.CLIENT_URL + '/specialties/search');
          window.location.assign('https://qwell.com/specialties/search');
        } else {
          sessionStorage.removeItem('redirect2');
          // window.location.assign('https://qwell.com/specialties/search');
          window.location.assign(
            process.env.REACT_APP_CLIENT_URL + '/specialties/search'
          );
        }
      } else {
        history.push('/patients');
      }
    }
  };

  origin = () => {
    const { location = {} } = this.props;
    const queryParams = queryString.parse(location.search);
    return queryParams.redirect;
  };

  onEmailChange = event => {
    this.setState({ email: event.target.value });
  };

  onPasswordChange = event => {
    this.setState({ password: event.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <CardForm
          headerText="Welcome"
          submitText="Sign In"
          errorText={this.state.errorMessage}
          onSubmit={this.handleSubmit}
        >
          <FormControl
            required
            fullWidth
            className={classes.formControl}
            margin="normal"
          >
            <TextField
              autoFocus
              fullWidth
              type="email"
              variant="outlined"
              label="Email"
              value={this.state.email}
              onChange={this.onEmailChange}
            />
          </FormControl>

          <FormControl
            required
            fullWidth
            className={classes.formControl}
            margin={'normal'}
          >
            <TextField
              fullWidth
              type={this.state.showPassword ? 'text' : 'password'}
              variant="outlined"
              label="Password"
              value={this.state.password}
              onChange={this.onPasswordChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={this.handleClickShowPassword}
                      onMouseDown={this.handleMouseDownPassword}
                      edge="end"
                    >
                      {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </CardForm>

        <div className={classes.metaActions}>
          <span className={classes.metaAction}>
            <Link to="/sign-up" component={RouterLink}>
              Don't have an account yet?
            </Link>
          </span>
          <span className={classes.metaAction}>
            <Link to="/password-reset" component={RouterLink}>
              Forgot/reset your password
            </Link>
          </span>
        </div>
        <Snackbar location={this.props.location || {}} />
      </div>
    );
  }
}

const styles = () => ({
  formControl: {
    display: 'block',
    margin: '1.5em 2em 0.5em 2em',
  },
  metaActions: {
    margin: '2em 0',
    color: '#8DABC4',
    textAlign: 'center',
    textDecoration: 'underline',
  },
  metaAction: {
    display: 'block',
    marginBottom: '10px',
  },
});

Login.contextType = CurrentUserContext;

export default withStyles(styles)(Login);
